export function isEmail(value) {
  return value.match('^[A-Za-z0-9-._%+-]+@[A-Za-z0-9.-]+[.][a-zA-Z]{2,}$') !== null;
}

export function isEqualsToOtherValue(value, otherValue) {
  return value === otherValue;
}
